import { FormGroup } from "@angular/forms";
import { InformationFormatting } from "src/app/core/helpers/information-formatting/information-formatting";
import { obtenerSolicitudTipoId } from "src/app/core/models/request/afiliaciones/solicitud-tipos.enum";
import { ObligatoriedadDocumentosService } from "src/app/core/services/obligatoriedadDocumento/obligatoriedadDocumento.service";
import { DocumentosParentesco } from "./documentos-parentesco";

export class DocumentosBeneficiario extends DocumentosParentesco {
  constructor(
    personaControl: FormGroup,
    formulario: FormGroup,
    documentosService: ObligatoriedadDocumentosService) {
    super(personaControl, formulario, documentosService);
  }

  async obtenerDocumentos(): Promise<void> {
    const edad = this.calcularEdad(this.datosPersona.fechaNacimiento as Date);
    var esCategoriaParaCuotaMonetaria = this.datosAdicionales.cm;
    if(this.datosAdicionales.solicitudId == "AFT"){
      esCategoriaParaCuotaMonetaria = !this.datosPersona.rangoC;
    }
    const filtro = {
      solicitudesTiposId: obtenerSolicitudTipoId(this.datosAdicionales.solicitudId),
      parentescosNombre: this.datosPersona.parentescoPerCarg["name"],
      edad,
      aplicaDiscapacidad: this.datosPersona.discapacidad,
      reglas: {
        parentesco: this.datosPersona.parentescoPerCarg["name"],
        ocupacion_conyuge: InformationFormatting.returnNameOccupattion(this.datosAdicionales.ocupacionConyuge) ?? 'Hogar',
        cm: esCategoriaParaCuotaMonetaria,
        discapacidad: this.datosPersona.discapacidad === "true" //Validacion para certificado escolar
      }
    };

    this.documentosService.documentosBeneficiario = await this.documentosService.obtenerDocumentosFiltrados(filtro);
    this.documentosService.documentosBeneficiarioSubject.next(this.documentosService.documentosBeneficiario);
  }
}
